import { useEffect } from 'react';

import { PacketBuilderContextProvider } from 'lib/context/PacketBuilder/PacketBuilderContextProvider';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import {
  isSubstepCompleted,
  resolveContinueAction
} from 'components/shared/OnboardingWizard/lib/resolveContinueAction';

import PacketBuilderProcess from './components/PacketBuilderProcess';

const OnboardingPackets = ({
  setHeaderButtonProps,
  navigateToSubstep,
  addFooterActions,
  mutateOrchestratorData,
  onNext,
  orchestratorData,
  orchestratorLoading
}) => {
  useEffect(() => {
    addFooterActions([
      {
        text: 'Continue',
        onClick: resolveContinueAction({
          isDirty: false,
          isCompleted: isSubstepCompleted(orchestratorData),
          hasExistingData: true,
          onConfirm: () => mutateOrchestratorData({}),
          onNext
        }),
        isDisabled: orchestratorLoading
      }
    ]);
  }, [
    setHeaderButtonProps,
    addFooterActions,
    orchestratorLoading,
    orchestratorData?.handlerStatus
  ]);

  return (
    <PacketBuilderContextProvider>
      <PacketBuilderProcess
        navigateToSubstep={navigateToSubstep}
        setHeaderButtonProps={setHeaderButtonProps}
      />
    </PacketBuilderContextProvider>
  );
};

export default withErrorBoundary(OnboardingPackets);
